<template>
  <section class="content" style="width: 80%;">
    <br><br>
    <div class="box">
      <div class="box-body" id="html-template" style="height: 100%;min-height: 500px;">
        <div class="col-md-12 mt-2">
          <hls-player :width="780" :height="450" :autoplay="false" :muted="true" :controls="true" ref="myPlayer" :source="schedulevideo"/>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import axios from 'axios'
import { BaseURLV3 } from '../shared/classes'
import Vue from 'vue'
import moment from 'moment'
import 'hls-player/dist/hls-player.css'
import hlsPlayer from 'hls-player'
Vue.use(moment)
export default {
  name: 'addFeedback',
  data () {
    return {
      scheduleDetails: [],
      vOption: {},
      schedulevideo: ''
    }
  },
  components: {
    hlsPlayer
  },
  created () {
    this.schedule_id = this.$route.params.id
    this.getscheduleDetails()
  },
  methods: {
    play (e) {
      console.log(e)
    },
    pause (e) {
      console.log(e)
      return false
    },
    getscheduleDetails () {
      const mainurl = '/interviewer/' + this.$route.params.id + '/feedback'
      axios.get(`${BaseURLV3}${mainurl}`, this.config).then(response => {
        this.schedulevideo = response.data.schedule.video_url
        this.vOption = {
          type: 'application/x-mpegURL',
          src: this.schedulevideo,
          preload: true,
          autoplay: false,
          isLoop: false,
          controls: 'progress,current,durration,volume',
          crossOrigin: false
        }
      })
    }
  }
}
</script>

<style scoped>
.products-list .item:hover {
  border-left: 3px solid #ffffff;
  background-color: #ffffff;
  cursor: pointer;
}
a:hover, a:active, a:focus {
  outline: none;
  text-decoration: none;
  color: #5bad2b;
}
.errorshow {
  background-color: #ff000047;
  padding: 5px;
  color: #dd4b39 !important;
}
.post li.active {
  background-color: #5bad2b !important;
  color: white !important;
  border: 0px !important;
}
.sideborder {
  border-right: 1px solid #cccccc52;
  min-height: 700px;
  height: 100%;
}
span.field-icon {
  position: absolute;
  display: inline-block;
  cursor: pointer;
  right: 2.5rem;
  top: 0.7rem;
  z-index: 2;
  margin-top: 4px;
}
.nav-stacked>li.active>a, .nav-stacked>li.active>a:hover {
    background: transparent;
    color:white;
    border-top: 0;
    border-left-color: #5bad2b ;
}
.ml-20 {
  margin-right: 20px;
}
.ml-36 {
  margin-right: 36px;
}
.p-5 {
  padding: 5px;
}
.container {
  display: block;
  position: relative;
  padding-left: 25px;
  margin-bottom: 12px;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

/* Hide the browser's default radio button */
.container input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
}

/* Create a custom radio button */
.checkmark {
  position: absolute;
  top: 0;
  left: 0;
  height: 20px;
  width: 20px;
  background-color: #eee;
  border-radius: 50%;
}

/* On mouse-over, add a grey background color */
.container:hover input ~ .checkmark {
  background-color: #ccc;
}

/* When the radio button is checked, add a blue background */
.container input:checked ~ .checkmark {
  background-color: #2196F3;
}

/* Create the indicator (the dot/circle - hidden when not checked) */
.checkmark:after {
  content: "";
  position: absolute;
  display: none;
}

/* Show the indicator (dot/circle) when checked */
.container input:checked ~ .checkmark:after {
  display: block;
}

/* Style the indicator (dot/circle) */
.container .checkmark:after {
  top: 6px;
  left: 6px;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: white;
}
.download-pdf {
  float: right;
  padding: 0px;
  padding-bottom: 15px;
}
</style>
